
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.824 9.37c.137.12.267.25.387.386l1.392-1.3a6.064 6.064 0 00-2.227-1.585L8.83 8.417a4.155 4.155 0 011.994.953zM8.06 12.687l2-1.864a2.654 2.654 0 00-2.884-.752L6.249 11l1.81 1.688zM12.891 4.357l-1.408 1.408c.538.275 1.04.614 1.495 1.01.245.216.476.447.691.692l1.392-1.3a9.345 9.345 0 00-2.17-1.81zM12.443 3.474l.567-.567-.707-.707-1.284 1.284A9.28 9.28 0 001.06 6.167l1.392 1.3a7.446 7.446 0 016.99-2.404l-1.34 1.34h-.04a6.07 6.07 0 00-4.543 2.056l1.304 1.22-1.715 1.715.665.666.042.041 8.628-8.627z","fill":"#6C7684"}})])
          )
        }
      }
    